/// <reference lib="dom" />

import { getOriginalFileName } from './file-utils'

export function downloadFile(file: Blob, name: string) {
   const url = window.URL.createObjectURL(file)
   const a = document.createElement('a')
   a.href = url
   a.download = name
   document.body.appendChild(a)
   a.click()
   window.URL.revokeObjectURL(url)
   document.body.removeChild(a)
}

export async function downloadFileFromUrl(url: string, fileName?: string) {
   try {
      // Fetch the file from the URL
      const response = await fetch(url)

      if (!response.ok) {
         throw new Error(`Failed to download file: ${response.statusText}`)
      }

      // Convert response to blob
      const blob = await response.blob()

      // If no fileName provided, try to extract from URL or use default. Extract ulid from fileName
      const name = getOriginalFileName(fileName || extractFileNameFromUrl(url) || 'download')

      // Use the existing downloadFile function
      downloadFile(blob, name)
   } catch (error) {
      console.error('Error downloading file:', error)
      throw error
   }
}

// Helper function to extract filename from URL
function extractFileNameFromUrl(url: string): string {
   try {
      const urlObj = new URL(url)
      const pathname = urlObj.pathname
      const segments = pathname.split('/')
      const lastSegment = segments[segments.length - 1]

      // Remove any query parameters and decode the filename
      const fileName = decodeURIComponent(lastSegment.split('?')[0])

      // Return filename if it has an extension, otherwise return empty string
      return fileName.includes('.') ? fileName : ''
   } catch {
      return ''
   }
}
